/** 
 * urlsearchparams
 * https://developers.google.com/web/updates/2016/01/urlsearchparams
 *  
 */ 

const checkboxes = [...document.querySelectorAll("input[type=checkbox]")]

// 
// get url params and fill form
function onLoad(urlParam) {   
  urlParam.forEach(function(value,key) {
    const formfield =  document.querySelector(`input[type=checkbox][name=${key}]`);
    formfield && (formfield.checked = true);
  });
  
}

//
// get checkbox values and update url
function onCheckboxChange(urlParam) { 
  checkboxes.forEach( (checkbox) => {
    checkbox.addEventListener( 'change', function() {
      if(this.checked) {
        urlParam.set(this.name, 1) 
      } else {
        urlParam.delete(this.name)
      }
      updateURL(urlParam)
    });

  })
  
}



function updateURL(urlParam) {
  window.history.replaceState({}, '', `${location.pathname}?${urlParam}`);
}

export default ( () => {
  if (!checkboxes.length) return; // exit, if page this has not the form
  const urlParam = new URLSearchParams(location.search);
  onLoad(urlParam) // update Checkboxes from urlParam
  onCheckboxChange(urlParam) // get checkbox values and update url
})();